import React, { Component } from 'react';
import * as Styles from './Styles';
import SvgLogosFooter from '../../../others/svg_dist/LogosFooter';
import moment from 'moment';
import SvgLogoMentor from '../../../others/svg_dist/LogoMentor';
import SvgEmail from '../../../others/svg_dist/Email';
import SvgPhone2 from '../../../others/svg_dist/Phone2';

type Props = {
	style?: React.CSSProperties;
};

type State = {};

class Footer extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper style={this.props.style}>
				<Styles.FooterTop id="kontakt">
					<Styles.TopHeadingFont>
						potrzebujesz <span>więcej informacji?</span>
					</Styles.TopHeadingFont>
					<Styles.TopFont>
						Zadzwoń do nas lub napisz e-mail, aby uzyskać informacje
						dotyczącą zakresu ubezpieczeń dostępnych na{' '}
						<span>wopr.mentor.pl</span>
					</Styles.TopFont>
					<Styles.TopFont>
						pracujemy od <span>poniedziałku do piątku</span> w
						godzinach <span>8:00 - 16:00</span>
					</Styles.TopFont>
					<Styles.FooterTopContactsContainer>
						<Styles.FooterTopContactMail>
							<div>
								<SvgEmail />
							</div>
							<p>
								<span>wopr@</span>mentor.pl
							</p>
						</Styles.FooterTopContactMail>
						<Styles.FooterTopContactsRightContainer>
							<Styles.FooterTopContactsRightCenterLogo>
								<img
									src="/decors/lifebuoy_1.png"
									alt="dekor koło ratunkowe"
								/>
								<SvgLogoMentor />
							</Styles.FooterTopContactsRightCenterLogo>
							<Styles.FooterTopContactsLeftContainer>
								<Styles.ContactPersonContainer>
									<Styles.ContactPersonIcon>
										<SvgPhone2 />
									</Styles.ContactPersonIcon>
									<div>
										<p>Michał Olejnik</p>
										<p>+48 56 669 33 07</p>
									</div>
								</Styles.ContactPersonContainer>
								<Styles.ContactPersonContainer>
									<Styles.ContactPersonIcon>
										<SvgPhone2 />
									</Styles.ContactPersonIcon>
									<div>
										<p>Róża Błaś</p>
										<p>+48 56 669 32 16</p>
									</div>
								</Styles.ContactPersonContainer>
							</Styles.FooterTopContactsLeftContainer>
						</Styles.FooterTopContactsRightContainer>
					</Styles.FooterTopContactsContainer>
				</Styles.FooterTop>
				<Styles.FooterBottom>
					<Styles.FooterBottomSection>
						<div>
							<Styles.FooterBottomFont>
								Mentor S.A. Broker Ubezpieczeniowy, ul. Szosa
								Chełmińska 177-181, 87-100 Toruń,
							</Styles.FooterBottomFont>
							<Styles.FooterBottomFont>
								tel.:+48 56 669 33 00, fax.:+48 56 669 33 04
							</Styles.FooterBottomFont>
						</div>
						<div style={{ marginTop: '50px' }}>
							<Styles.FooterBottomFont>
								Sąd Rejonowy w Toruniu, VII Wydział Gospodarczy,
								NIP: 956 00 03 240, KRS: 31423,
							</Styles.FooterBottomFont>
							<Styles.FooterBottomFont>
								kapitał zakładowy w kwocie 784 628,00 zł
								opłacony w całości
							</Styles.FooterBottomFont>
						</div>
					</Styles.FooterBottomSection>
					<Styles.FooterBottomSection>
						<SvgLogosFooter />
						<Styles.FooterBottomFont style={{ marginTop: '50px' }}>
							© 1994-{moment().year()} Mentor S.A. // All Rights
							Reserved{' '}
							<a
								href="/downloads/regulamin_oraz_polityka_prywatnosci.pdf"
								target="_blank"
							>
								Regulamin oraz polityka prywatności
							</a>
						</Styles.FooterBottomFont>
					</Styles.FooterBottomSection>
				</Styles.FooterBottom>
			</Styles.Wrapper>
		);
	}
}

export default Footer;
